// extracted by mini-css-extract-plugin
module.exports = {"container":"NotAllowedWarning_container__yZdIN","title":"NotAllowedWarning_title__WnrQf","description":"NotAllowedWarning_description__uC1DT"};